module.exports = __webpack_public_path__ + "static/media/YF26_2.a15819aa.jpg";